import PrivacyVersionLayout from './PrivacyVersionLayout'

export default function PrivacyV101() {
  return (
    <PrivacyVersionLayout version="1.0.1" date="17/01/2024">
      <div dangerouslySetInnerHTML={{ __html: privacyContent }} />
    </PrivacyVersionLayout>
  )
}

const privacyContent = `
  <p>Titolare del trattamento ai sensi delle leggi vigenti è la società <strong>ItalConnect S.r.l.</strong> (d'ora innanzi per brevità "Società") con sede legale in Via Alessandro Volta 24, 20099 Sesto San Giovanni (MI) P. IVA IT10663330966, indirizzo e-mail <strong>amministrazione@italconnectsrl.it</strong>, nella persona del suo Rappresentante Legale Dott. Luigi Zavatta, in qualità di Titolare del Trattamento.</p>
  
  <h2>1. Finalità del trattamento</h2>
  <p>Il trattamento dei dati raccolti dal sito è effettuato per le seguenti finalità:</p>
  <ul>
    <li><strong>1.1 Statistica (analisi):</strong> Raccolta di dati e informazioni in forma esclusivamente aggregata e anonima al fine di verificare il corretto funzionamento del sito.</li>
    <li><strong>1.2 Sicurezza:</strong> Raccolta di dati e informazioni al fine di tutelare la sicurezza del sito e degli utenti.</li>
    <li><strong>1.3 Esecuzione dei servizi richiesti:</strong> I dati personali forniti saranno trattati per finalità strettamente connesse all'esecuzione dei servizi richiesti dagli utenti.</li>
    <li><strong>1.4 Marketing:</strong> Utilizzo dei dati personali, solo previo consenso esplicito, per inviare comunicazioni promozionali.</li>
  </ul>
  
  <h2>2. Dati raccolti</h2>
  <p>Il presente sito raccoglie dati degli utenti in due modi: dati raccolti in maniera automatizzata e dati raccolti durante la navigazione degli Utenti.</p>
  <p>Possono essere raccolte le seguenti informazioni:</p>
  <ul>
    <li>Internet Protocol address (IP);</li>
    <li>Tipo di browser;</li>
    <li>Parametri del dispositivo usato per connettersi al sito;</li>
    <li>Nome dell'internet service provider (ISP);</li>
    <li>Data e orario di visita;</li>
    <li>Pagina web di provenienza del visitatore (referral) e di uscita.</li>
  </ul>
  
  <h2>3. Dati conferiti volontariamente</h2>
  <p>Il sito può raccogliere altri dati in caso di utilizzo volontario di servizi da parte degli utenti:</p>
  <ul>
    <li>Nome e cognome;</li>
    <li>Numero di telefono.</li>
  </ul>
  
  <h2>4. Luogo del trattamento</h2>
  <p>I dati sono trattati presso la sede del Titolare del Trattamento, e presso il datacenter del web Hosting.</p>
  
  <h2>5. Cessione dei dati</h2>
  <p>I dati personali, previo consenso espresso per tale finalità, potranno essere ceduti per finalità commerciali e di marketing. La lista dei soggetti terzi ai quali potranno essere ceduti i dati:</p>
  <ul>
    <li><strong>ENI PLENITUDE S.P.A. SOCIETA' BENEFIT,</strong> con sede in Milano, Via Giovanni Lorenzini n. 4 – Partita IVA 12300020158</li>
    <li><strong>ENEL ENERGIA S.P.A.,</strong> con sede legale in Roma, via Luigi Boccherini n. 15 – Partita IVA 06655971007</li>
    <li><strong>SKY ITALIA S.R.L.,</strong> con sede legale in Milano, via Monte Penice n. 7 – Partita IVA 04619241005</li>
    <li><strong>TIM S.P.A.,</strong> con sede legale in Milano, Via Gaetano Negri n° 1 – Partita IVA 00488410010</li>
  </ul>
  
  <h2>6. Diritti dell'Interessato</h2>
  <p>Con riferimento ai dati personali trattati dalla Società, Lei ha il diritto di esercitare i seguenti diritti ai sensi del GDPR:</p>
  <ul>
    <li>Diritto di accesso (art. 15 GDPR)</li>
    <li>Diritto di rettifica (art. 16 GDPR)</li>
    <li>Diritto alla cancellazione (art. 17 GDPR)</li>
    <li>Diritto di limitazione del trattamento (art. 18 GDPR)</li>
    <li>Diritto alla portabilità dei dati (art. 20 GDPR)</li>
    <li>Diritto di opposizione (art. 21 GDPR)</li>
  </ul>
  <p>Per esercitare i Suoi diritti, può inviare una richiesta scritta al Titolare del trattamento all'indirizzo e-mail: <strong>amministrazione@italconnectsrl.it</strong></p>
`
